






















import { Component, Prop, Vue } from 'vue-property-decorator'
import { CssjsParse } from '@/interfaces/cssjs.interface'
import { Cssjs } from '@/utilities/cssjs.utility.js'

// Initialize parser object
const cssjsInstance = new Cssjs();

@Component
export default class DashboardForm extends Vue {
  // public cssParsed!: CssjsParse;
  public cssInput: string = '';
  
  /**
   * @description take in input the css to parse
   */
  public parseCss() {
    this.$emit('css-parsed', cssjsInstance.parseCSS(this.cssInput))
  }
  
}
